import { render, staticRenderFns } from "./CRUDParametros.vue?vue&type=template&id=1bac61f1&scoped=true&"
import script from "./CRUDParametros.vue?vue&type=script&lang=js&"
export * from "./CRUDParametros.vue?vue&type=script&lang=js&"
import style0 from "./CRUDParametros.vue?vue&type=style&index=0&id=1bac61f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bac61f1",
  null
  
)

export default component.exports